import { API_ENDPOINTS } from "../../Api/apiEndPoints"
import axiosInstance from "../../Api/axiosInstance"

export const getListNotificationConfiguration = async(params={})=>{
    let  response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_NOTIFICATION_LIST,{params:params});
    return response?.data; 
}

export  const getSingleNotifaiction = async(id:number)=>{
   let respose = await axiosInstance.get(`${API_ENDPOINTS.CONFIGURATION.GET_SINGLE_NOTIFICATOIN}/${id}`);
   return respose?.data; 
}


interface ReqBody {
  Frequency?:number |null
  NotificationType: string,
  Orgunitid: null | number,
  IsEnabled: number,
  NotificationTime: string,
  NotificationSubject: string,
  NotificationDate:string | null,
  NotificationMessage:string,
  RedirectScreen: string,
  Grades: number[],
  Positions:number[]
}

export const addNotificationConfiguration = async({ReqBody}:{ReqBody:ReqBody})=>{
   let url = `${API_ENDPOINTS.CONFIGURATION.POS_ADD_NOTIFICATION}`
   let response  = await axiosInstance.post(url,ReqBody);
}

export const updateNotifiaction = async({id,ReqBody}:{id:number,ReqBody:any})=>{
    const url = `${API_ENDPOINTS.CONFIGURATION.PUT_UPDATE_NOTIFICATIOIN}/${id}`;
    let respone = await axiosInstance.put(url,ReqBody);
}

export const getALlRolesList = async(params={})=>{
    let response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_ROLES_LIST,{params:params});
   const DataforRoles = response.data?.data?.data?.map((item: any) => {
    return {
      id: item?.RoleId || '',
      label: String(item?.RoleName) || '',
    };
  });  
    return DataforRoles;
}


export const getGradList = async ()=>{
  let response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_GRADE_LIST);
  const rowData = await response?.data;

  const formatedData =Array.isArray(response?.data?.data) ? response?.data?.data.map((item:any)=>({
  id:item.Gradeid,
  name:item.GradeName
  })) : [] 
  return {formatedData,rowData};
}


export const getPositionList= async(params={})=>{
  let respone = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_POSITION_LIST,{params:params});
  const rowData = await respone.data; 
  const formatedData = Array.isArray(rowData.data.Positions)? rowData.data.Positions.map((item:any)=>({
    id:item.PositionId,
    label:item.PositionName
  })) :[]
  return{formatedData,rowData}
}
